// extracted by mini-css-extract-plugin
export default {"panel_info":"Panel_panel_info__l4wak","static_panel_info":"Panel_static_panel_info__FhagM","sticky":"Panel_sticky__YxhWV"};